import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface CheckoutStepsAccordionProps {
  steps: string[];
  activeStep: number;
  renderStepContent: (step: number) => React.ReactNode;
  onBack: (step: number) => void;
  onNext: (step: number) => void;
  canGoNext?: (step: number) => boolean;
  canGoBack?: (step: number) => boolean;
  nextLabel?: string;
  backLabel?: string;
}

const CheckoutStepsAccordion: React.FC<CheckoutStepsAccordionProps> = ({
  steps,
  activeStep,
  renderStepContent,
  onBack,
  onNext,
  canGoNext,
  canGoBack,
  nextLabel = "Próximo",
  backLabel = "Voltar",
}) => {
  return (
    <>
      {steps.map((label, index) => (
        <Accordion
          key={label}
          expanded={activeStep === index}
          disabled={index > activeStep}
          sx={{ mb: 2 }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`step-content-${index}`}
            id={`step-header-${index}`}
          >
            {activeStep !== index && (
              <Typography variant="h6">{label}</Typography>
            )}
          </AccordionSummary>
          <AccordionDetails>
            {renderStepContent(index)}
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}
            >
              {index !== steps.length - 1 && (
                <Button
                  onClick={() => onBack(index)}
                  sx={{ mr: 1 }}
                  disabled={canGoBack ? !canGoBack(index) : index === 0}
                >
                  {backLabel}
                </Button>
              )}
              <Box>
                {index !== steps.length - 1 && (
                  <Button
                    variant="contained"
                    onClick={() => onNext(index)}
                    disabled={canGoNext ? !canGoNext(index) : false}
                  >
                    {nextLabel}
                  </Button>
                )}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};

export default CheckoutStepsAccordion;
